import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-start" }
const _hoisted_2 = { class: "d-flex flex-row mt-3" }
const _hoisted_3 = { class: "code-box code-box--with-border" }
const _hoisted_4 = {
  class: "text color--info",
  ref: "keyRSA"
}
const _hoisted_5 = { class: "d-flex flex-row mt-3" }
const _hoisted_6 = { class: "code-box code-box--with-border" }
const _hoisted_7 = {
  class: "text color--info",
  ref: "extractHash"
}
const _hoisted_8 = { class: "d-flex flex-row mt-3" }
const _hoisted_9 = { class: "code-box code-box--with-border" }
const _hoisted_10 = {
  class: "text color--info",
  ref: "signAWS"
}
const _hoisted_11 = {
  class: "alert alert-dismissible alert-warning mt-3",
  role: "alert"
}
const _hoisted_12 = { class: "alert__icon" }
const _hoisted_13 = { class: "d-flex flex-row mt-3" }
const _hoisted_14 = { class: "code-box code-box--with-border" }
const _hoisted_15 = {
  class: "text color--info",
  ref: "publicKey"
}
const _hoisted_16 = { class: "d-flex flex-row mt-3" }
const _hoisted_17 = { class: "code-box code-box--with-border" }
const _hoisted_18 = {
  class: "text color--info",
  ref: "base64ToDer"
}
const _hoisted_19 = { class: "d-flex flex-row mt-3" }
const _hoisted_20 = { class: "code-box code-box--with-border" }
const _hoisted_21 = {
  class: "text color--info",
  ref: "convertToExpectedFormat"
}
const _hoisted_22 = { class: "d-flex flex-row mt-3" }
const _hoisted_23 = { class: "code-box code-box--with-border" }
const _hoisted_24 = {
  class: "text color--info",
  ref: "signUsingKeyAWS"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"text mt-4\">Documentação AWS:</div><div class=\"text mt-4\">KMS:</div><a href=\"https://docs.aws.amazon.com/cli/latest/reference/kms/index.html\" target=\"_blank\"><div class=\"text color--info\">https://docs.aws.amazon.com/cli/latest/reference/kms/index.html</div></a><div class=\"text\">Geração da chave:</div><a href=\"https://docs.aws.amazon.com/cli/latest/reference/kms/create-key.html\" target=\"_blank\"><div class=\"text color--info\">https://docs.aws.amazon.com/cli/latest/reference/kms/create-key.html</div></a><div class=\"text\">Obter chave pública:</div><a href=\"https://docs.aws.amazon.com/cli/latest/reference/kms/get-public-key.html\" target=\"_blank\"><div class=\"text color--info\">https://docs.aws.amazon.com/cli/latest/reference/kms/get-public-key.html</div></a><div class=\"text\">Assinatura:</div><a href=\"https://docs.aws.amazon.com/cli/latest/reference/kms/sign.html\" target=\"_blank\"><div class=\"text color--info\">https://docs.aws.amazon.com/cli/latest/reference/kms/sign.html</div></a><div class=\"h6 mt-4\"><strong>Chave privada</strong></div><div class=\"text mt-4\">Gerar chave RSA 2048 bits:</div>", 11)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _cache[14] || (_cache[14] = [
          _createTextVNode("$ aws kms create-key --description \""),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "cert1", -1),
          _createTextVNode("\" --key-usage SIGN_VERIFY --customer-master-key-spec RSA_2048")
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-key-rsa",
        name: "copy",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doCopy(this.$refs.keyRSA, 1))),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetContent(1))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"text mt-4\">Resultado esperado:</div><div class=\"code-box mt-3\"><div class=\"text\">{<br>    &quot;KeyMetadata&quot;: {<br>     &quot;AWSAccountId&quot;: &quot;<span class=\"red-background\">&lt;ID da conta AWS&gt;</span>&quot; ,<br>     &quot;KeyId&quot;: &quot;<span class=\"red-background\">&lt;ID da chave&gt;</span>&quot; ,<br>     &quot;Arn&quot;: &quot;arn:aws:kms: <span class=\"red-background\">&lt;regiao&gt;</span>:<span class=\"red-background\">&lt;ID da conta AWS&gt;</span>:key/<span class=\"red-background\">&lt;ID da chave&gt;</span>&quot;,<br>     &quot;CreationDate&quot;: 1654625481.9,<br>     &quot;Enabled&quot;: true,<br>     &quot;Description&quot;: &quot;<span class=\"red-background\">cert1</span>&quot;,<br>     &quot;KeyUsage&quot;: &quot;SIGN_VERIFY&quot;,<br>     &quot;KeyState&quot;: &quot;Enabled&quot;,<br>     &quot;Origin&quot;: &quot;AWS_KMS&quot;,<br>     &quot;KeyManager&quot;: &quot;CUSTOMER&quot;,<br>     &quot;CustomerMasterKeySpec&quot;: &quot;RSA_2048&quot;,<br>     &quot;SigningAlgorithms&quot;: [<br>         &quot;RSASSA_PKCS1_V1_5_SHA_256&quot;,<br>         &quot;RSASSA_PKCS1_V1_5_SHA_384&quot;,<br>         &quot;RSASSA_PKCS1_V1_5_SHA_512&quot;,<br>         &quot;RSASSA_PSS_SHA_256&quot;,<br>         &quot;RSASSA_PSS_SHA_384&quot;,<br>         &quot;RSASSA_PSS_SHA_512&quot;<br>     ]<br>   }<br> }<br></div></div><h2 class=\"mt-5\">Assinar termo digital</h2><div class=\"text mt-4\">AWS KMS espera o DIGEST puro a ser assinado, então é preciso extrair essa informação a partir da estrutura PKCS#1 do arquivo <span class=\"red-background\">digitalterm_hash.bin</span></div><div class=\"text mt-4\">Extrair o hash/digest puro do PKCS#1:</div>", 5)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _cache[15] || (_cache[15] = [
          _createTextVNode("$ openssl asn1parse -inform der -in "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "digitalterm_hash.bin", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-extract-hash",
        name: "copy",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doCopy(this.$refs.extractHash, 2))),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetContent(2))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"text mt-4\">Resultado esperado:</div><div class=\"code-box mt-3\"><div class=\"text\">0:d=0 hl=2 l= 47 cons: <br>2:d=1 hl=2 l= 11 cons: SEQUENCE<br> 4:d=2 hl=2 l= 9 prim: OBJECT :sha256<br> 15:d=1 hl=2 l= 32 prim: OCTET STRING [HEX<br> DUMP]:<span class=\"red-background\">458A364F84551E45D29B9F2168ED9F2F7347A7ECADBA153C5D47A1150C6662E9</span></div></div><div class=\"text mt-4\">Salve o HEX DUMP em um arquivo <span class=\"red-background\">hash.hex</span> e depois converta de hexadecimal para binário <span class=\"red-background\">hash.bin</span></div><div class=\"text mt-4\">Assinar usando chave privada AWS KMS:</div>", 4)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _cache[16] || (_cache[16] = [
          _createTextVNode("$ aws kms sign --key-id \""),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "<ID da chave>", -1),
          _createTextVNode("\" --message fileb://"),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "hash.bin", -1),
          _createTextVNode(" --signing-algorithm RSASSA_PKCS1_V1_5_SHA_256 --message-type DIGEST")
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-sign-aws",
        name: "copy",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.doCopy(this.$refs.signAWS, 3))),
        onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetContent(3))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[25] || (_cache[25] = _createStaticVNode("<h2 class=\"mt-5\">Requisição (CSR)</h2><div class=\"text mt-4\">Gere o CSR na sua aplicação, que fará uso da chave no AWS KMS.</div><div class=\"text mt-4\">Se a aplicação não der suporte à geração do CSR, gere um CSR no OpenSSL com uma chave qualquer (RSA 2048). Então substitua no CSR a chave pública inserindo a do AWS KMS, e faça nova assinatura do CSR usando a chave privada no AWS KMS.</div><div class=\"text mt-4\">Essa é uma operação complexa. Recomendamos o uso de um script que faça esse trabalho, como o disponível neste repositório: <a href=\"https://github.com/g-a-d/aws-kms-sign-csr\" target=\"_blank\"><span class=\"text color--info\">https://github.com/g-a-d/aws-kms-sign-csr</span></a><br> IMPORTANTE: é um repositório público, utilize somente após verificar o código e atestar que é seguro para a sua operação</div>", 4)),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Icon, { name: "circle-info" })
      ]),
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "alert__content" }, [
        _createElementVNode("div", { class: "text" }, [
          _createElementVNode("strong", null, "Importante"),
          _createTextVNode(": É um repositório público, utilize somente após verificar o código e atestar que é seguro para a sua operação.")
        ])
      ], -1))
    ]),
    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text mt-4" }, "Mas se preferir o método manual, alguns comandos que podem ser úteis no processo:", -1)),
    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text mt-4" }, "Obter a chave pública:", -1)),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, _cache[18] || (_cache[18] = [
          _createTextVNode("$ aws kms get-public-key --output text --query PublicKey --key-id \""),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "<ID da chave>", -1),
          _createTextVNode("\" > "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "chave_publica_base64", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-public-key",
        name: "copy",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.doCopy(this.$refs.publicKey, 4))),
        onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resetContent(4))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text mt-4" }, "Converta de base64 para formato DER:", -1)),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, _cache[19] || (_cache[19] = [
          _createTextVNode("$ base64 --decode "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "chave_publica_base64", -1),
          _createTextVNode(" > "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "pub_key_der", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-base64-to-der",
        name: "copy",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.doCopy(this.$refs.base64ToDer, 5))),
        onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetContent(5))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text mt-4" }, "Faça a conversão para o formato esperado pelo OpenSSL:", -1)),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, _cache[20] || (_cache[20] = [
          _createTextVNode("$ openssl rsa -pubin -pubout -inform der -in "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "pub_key_der", -1),
          _createTextVNode(" -out "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "pub_key", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-convert-to-expected-format",
        name: "copy",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.doCopy(this.$refs.convertToExpectedFormat, 6))),
        onMouseleave: _cache[11] || (_cache[11] = ($event: any) => (_ctx.resetContent(6))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text mt-4" }, "Assinar usando chave privada AWS KMS:", -1)),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, _cache[21] || (_cache[21] = [
          _createTextVNode("$ aws kms sign --key-id \""),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "<ID da chave>", -1),
          _createTextVNode("\" --message"),
          _createElementVNode("br", null, null, -1),
          _createElementVNode("br", null, null, -1),
          _createTextVNode(" fileb://"),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "csr_to_be_signed_der", -1),
          _createTextVNode(" --signing-algorithm"),
          _createElementVNode("br", null, null, -1),
          _createElementVNode("br", null, null, -1),
          _createTextVNode(" RSASSA_PKCS1_V1_5_SHA_256 --message-type RAW")
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-sign-using-key-aws",
        name: "copy",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.doCopy(this.$refs.signUsingKeyAWS, 7))),
        onMouseleave: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resetContent(7))),
        style: {"cursor":"pointer"}
      })
    ])
  ]))
}